import { render, staticRenderFns } from "./ConfigurationDoc.vue?vue&type=template&id=495be5d8"
import script from "./ConfigurationDoc.vue?vue&type=script&lang=js"
export * from "./ConfigurationDoc.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationDoc.vue?vue&type=style&index=0&id=495be5d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports